import { Component } from '@angular/core';

@Component({
  selector: 'us-registration-promotion-pill',
  standalone: true,
  templateUrl: './registration-promotion-pill.component.html',
  styleUrls: ['./registration-promotion-pill.component.scss'],
})
export class RegistrationPromotionPillComponent {}
